/**
 * Config: Canvas
 * -----------------------------------------------------------------------------
 * Custom config for Canvas, allows limited access to compiler config.
 *
 */
module.exports = {

  /**
   * Theme scripts async config.
   * - Scripts included will be loaded with `async` attribute.
   * - Other scripts default to `defer` attribute.
   */
  asyncScripts: [
    'global-components.bundle.min.js',
    'layout.password.js',
    'layout.theme.js',
    'vendors.bundle.min.js',
  ],

  /**
   * CSS optimiser config.
   * - `classes` - Set classes to optimise (remove if not used).
   * - `enable` - Whether to run optimiser.
   * - `stylesheets` - Set stylesheets to optimise (remove unused classes from).
   */
   cssOptimiser: {
    classes: [
      'grid',
      'text-',
    ],
    enable: false,
    stylesheets: ['layout.theme.css'],
  },

  /**
   * Array of custom elements not to be compiled by Vue.
   */
  customElements: [
    'aftership-aedd', 'swiper-container', 'swiper-slide', 'dmixer-generic-discount',
  ],

  /**
   * Set to true if using the custom content tool.
   */
  customContentTool: false,
}
